module.exports = __webpack_public_path__ + "img/search-pagination.277fe6a1.gif";